<template>
	<div>
		<navTitle>
			<div class="flex flex-align-center flex-jus-center">
				<div class="selectCenter flex flex-align-center flex-jus-center" @click="resourcesPopShow = true">
					<span>{{majorName ? majorName : '请选择'}}</span>
					<img src="@/static/images/icon-arrowRight2.png" alt="" />
				</div>
			</div>
		</navTitle>
		<van-list
			v-model="loading"	
			:finished="finished"
			:immediate-check="false"
			finished-text="没有更多了"
			@load="onLoad"
			:offset="10"
		>
			<!-- <div class="teachersList flex flex-wrap flex-align-center flex-jus-between">
				<div class="teachers" v-for="item in teacherList" :key="item.id">
					<img :src="item.avatar" alt="" />
				</div>
			</div> -->
			<div class="recommendList flex flex-wrap flex-align-center">
				<div @click="$router.push(`/home/teacher/detail?id=${item.id}`)" class="recommend flex flex-column flex-align-center" v-for="item in teacherList" :key="item.id" >
					<img :src="item.avatar" class="avatar">
					<div class="name">{{item.truename}}</div>
					<div class="des">福建省民族管弦乐 学会会员</div>
				</div>
			</div>
		</van-list>

		<resourcesPop :majorId="majorId" :resourcesPopShow.sync="resourcesPopShow" @changeResourcesPop="changeResourcesPop"></resourcesPop>
	</div>
</template>

<script>
import resourcesPop from '@/views/components/resourcesPop.vue';
/* eslint-disable */
export default {
	components: {
		resourcesPop
	},
	data() {
		return {
			resourcesPopShow: false,
			majorId: '',
			majorName: '',
			page: 1,
			teacherList: [],
			loading: false,
      finished: false
		};
	},
	created() {
		this.majorId = localStorage.getItem('majorId') || ''
		this.majorName = localStorage.getItem('majorName') || ''
		this.getTeacher()
	},
	mounted() {
		this.$wx.ready(() => {
      this.$wx.updateAppMessageShareData({
        title: '福建省民族管弦乐学会',
        desc: '名师风采',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
      this.$wx.updateTimelineShareData({
        title: '福建省民族管弦乐学会',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
    });
	},
	methods: {
		getTeacher() {
			this.$get('api/user/getUserAuthenticationList', {
				major_id: this.majorId,
				page: this.page,
				pageSize: 10
			}).then(res => {
				this.loading = false;
        let rows = res.data;
        if (rows == null || rows.length === 0) {
          this.finished = true;
          return;
        }
        this.teacherList = this.teacherList.concat(rows);

			})
		},
		onLoad() {
			this.page++;
      if (this.page > 1) {
        this.getTeacher();
      }
		},
		changeResourcesPop(data) {
			this.majorId = data.id
			this.majorName = data.name
			localStorage.setItem('majorId', this.majorId)
			localStorage.setItem('majorName', this.majorName)
			this.resourcesPopShow = false
		}
	}
};
</script>

<style scoped lang="stylus">
.selectCenter
	margin 0 auto
	min-width 160px
	height 64px
	border 2px solid #FFFFFF
	border-radius 38px
	font-size 28px
	color #FFFFFF
	padding 0 12px
	span
		word-break keep-all
	img
		margin-left 8px
		width 12px
		height 22px
.teachersList
	padding 24px 30px
	.teachers
		margin-bottom 22px
		width 334px
		height 380px
		background rgba(0, 0, 0, 0)
		border-radius 10px
		img
			width 100%
			height 100%
			border-radius 10px
.recommendList
	margin-top 32px
	padding 0 30px
	.recommend
		width 334px
		height 405px
		background-image url('~@/static/images/index/recommendBG.png')
		background-size 100% 100%
		background-position center
		padding 22px 14px
		text-align center
		margin-right 14px
		margin-bottom 14px
		&:nth-child(3n)
			margin-right 0
		.avatar
			width 148px
			height 148px
			border-radius 50%
		.name
			margin-top 24px
			font-size: 32px;
			font-weight: bold;
			color: #111111;
		.des
			margin-top 24px
			width 100%
			font-size: 26px;
			color: #7B6E5F;
</style>
